export default __webpack_public_path__ + "caf2822b2be7b19a43751d694b805f90.png";